import React from 'react';
import Seo from '../components/Seo';
import './Consulting.css';

const Consulting = () => {
  return (
    <div className="container consulting">
      <Seo
        title="Consulting | Clean Sweeps"
        description="Consulting and strategy support for Shopify sweepstakes, configuration, and rollout."
        path="/consulting"
        image="/og/consulting.png"
        imageAlt="Clean Sweeps consulting"
      />
      <section className="consulting-contact">
        <h1>Talk with our team</h1>
        <p>
          Need help with your sweepstakes? Tell us about your store and what
          you’d like help with.
        </p>
        <a
          className="consulting-email"
          href="mailto:info@cleansweeps.app?subject=Clean%20Sweeps%20Consulting%20Inquiry"
        >
          Email info@cleansweeps.app
        </a>
      </section>
    </div>
  );
};

export default Consulting;
